module.exports = __webpack_public_path__ + "8d6f588e1df694b6f2f54cc73cb4d8c9.png";